const en = {
  title: 'Notifications', empty: 'New activity will appear here', watch: 'Notify me about this author’s comments',
  unwatch: 'Turn off notifications about this author', newActivity: 'New activity',
  likes: '{{name}} liked your opinion', reposts: '{{name}} reposted your comment',
  subscriptions: '{{name}} followed you', author_comments: '{{name}} posted a new comment',
  authorCommentsSetting: 'New comments from authors', permissionDenied: 'Notifications were not enabled.',
  permissionDeniedIOS: 'Notifications are blocked in iPhone settings.',
  permissionDeniedAndroid: 'Notifications are blocked in Android settings.',
  deviceBrowser: 'Device notifications are available in the WIW app. These switches save your account preferences.',
  deviceUnavailable: 'Device notifications are not available here yet. Reopen the updated WIW app and try again.',
  devicePrompt: 'Permission has not been requested on this device.',
  deviceUnknown: 'Device permission has not been confirmed.',
  deviceRegistering: 'Connecting this device…', deviceUnregistered: 'This device is not connected for notifications.',
  openDeviceSettings: 'Open device settings', connectDevice: 'Connect this device',
  registrationFailed: 'Could not enable device notifications. Please try again.',
};
const ru = {
  title: 'Уведомления', empty: 'Здесь появятся новые события', watch: 'Уведомлять о комментариях автора',
  unwatch: 'Выключить уведомления об авторе', newActivity: 'Новые события',
  likes: '{{name}} оценил ваше мнение', reposts: '{{name}} репостнул ваш комментарий',
  subscriptions: '{{name}} подписался на вас', author_comments: '{{name}} оставил новый комментарий',
  authorCommentsSetting: 'Новые комментарии авторов', permissionDenied: 'Уведомления не включены.',
  permissionDeniedIOS: 'Уведомления запрещены в настройках iPhone.',
  permissionDeniedAndroid: 'Уведомления запрещены в настройках Android.',
  deviceBrowser: 'Уведомления на устройство доступны в приложении WIW. Эти тумблеры сохраняют предпочтения аккаунта.',
  deviceUnavailable: 'Уведомления на этом устройстве пока недоступны. Откройте обновлённое приложение WIW и попробуйте ещё раз.',
  devicePrompt: 'Разрешение на этом устройстве ещё не запрашивалось.',
  deviceUnknown: 'Разрешение устройства пока не подтверждено.',
  deviceRegistering: 'Подключаем устройство…', deviceUnregistered: 'Устройство не подключено к уведомлениям.',
  openDeviceSettings: 'Открыть настройки устройства', connectDevice: 'Подключить устройство',
  registrationFailed: 'Не удалось включить уведомления на устройстве. Попробуйте ещё раз.',
};
const translations = { en, ru };
export default translations;
